import { useNavigate } from "react-router-dom";

interface LogoProps {
  userName?: string;
}

export const Logo = ({ userName }: LogoProps) => {
  const navigate = useNavigate();

  return (
    <div>
      <img 
        src="/lovable-uploads/d8edf8a7-daeb-4805-8270-304464f41613.png" 
        alt="MindTube" 
        className="h-8 md:h-10 w-auto transition-all duration-300 cursor-pointer hover:opacity-80"
        onClick={() => navigate("/workspace")}
      />
      {userName && (
        <p className="text-sm text-muted-foreground mt-1">
          Welcome, {userName}
        </p>
      )}
    </div>
  );
};